function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M19 10.333a1 1 0 010 2h-1.253a.333.333 0 00-.235.097l-3.451 3.451a.167.167 0 000 .236l2.744 2.744a.667.667 0 11-.943.943l-2.744-2.744a.167.167 0 00-.236 0l-2.744 2.744a.667.667 0 11-.943-.943l2.744-2.743a.167.167 0 000-.236l-3.451-3.451a.333.333 0 00-.235-.098H4.667A.667.667 0 014 11.667V11c0-.368.298-.667.667-.667zm-3.679 2H10.68a.167.167 0 00-.118.284l2.321 2.322a.167.167 0 00.236 0l2.321-2.322a.167.167 0 00-.118-.284zM6.88 4.178a.667.667 0 01.907 0A3.451 3.451 0 019 6.561v2.772c0 .184-.15.334-.333.334H6a.333.333 0 01-.333-.334V6.561A3.457 3.457 0 016.88 4.178z"
});

function SvgIronAndIroningBoard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgIronAndIroningBoard;